import React from 'react'
import {Link} from 'react-router-dom'
import {useTranslation} from 'react-i18next'

import {PinIcon} from 'components/CustomIcons'
import priceParser from 'utils/priceParser'
import productDetailLink from 'utils/productDetailLink'

const Product = ({metaProduct, product: productProp}) => {
  const {t} = useTranslation()

  const product = productProp ?? metaProduct.product
  const type = metaProduct?.type ?? product.type
  const prod = type === 'ean' ? product[Object.keys(product)[0]] : product

  return (
    <Link to={() => productDetailLink(prod, type)}>
      <div className='productItem'>
        <div className='mainImage'>
          <img src={prod?.main_image_url} alt={prod?.name ?? prod.uuid}/>
          <div className='circle'>
            <div className='innerCircle'>
              <div className='shopNow'>
                {t('SHOP NOW')}
              </div>
            </div>
          </div>
        </div>
        <p className='titleText'>{prod?.name ?? prod.uuid}</p>
        <div className='priceLine'>
          {type === 'ean' && <div className='fromSign'>{t('from')}:</div>}
          <div className='price'>{priceParser(metaProduct?.fromPrice)}</div>
        </div>
        <div className='storesLine'>
          <div className='locationImage'>
            <PinIcon/>
          </div>
          <div className='shopLine'>
            {type === 'ean' ? t('in multiple shops') : t('in one shop')}
          </div>
        </div>
      </div>
    </Link>
  )
}

export default Product
